export var IOType;
(function (IOType) {
    IOType["IMPORT"] = "IMPORT";
    IOType["EXPORT"] = "EXPORT";
})(IOType || (IOType = {}));
